import {
  BookOpen, Brain, Briefcase, Check, Compass, Globe, Goal, GraduationCap,
  Handshake, Heart, Laptop, Lightbulb, Map, MessageCircle, Shield, Smile,
  Sprout, Star, Target, TrendingUp, Users,
} from "lucide-react";
import React from "react";

// Theme banners are lucide icons uploaded as SVGs and named after the icon
// ("goal.svg"). They are authored with stroke="currentColor", which renders
// black in an <img> and nothing at all through a CSS mask, so neither can be
// tinted to the section colour. The icon is resolved by filename and drawn from
// lucide-react instead, which inherits colour correctly.
//
// An icon outside this map falls back to Check, matching the Android app.
const ICONS = {
  'book-open': BookOpen,
  brain: Brain,
  briefcase: Briefcase,
  compass: Compass,
  globe: Globe,
  goal: Goal,
  'graduation-cap': GraduationCap,
  handshake: Handshake,
  heart: Heart,
  laptop: Laptop,
  lightbulb: Lightbulb,
  map: Map,
  'message-circle': MessageCircle,
  shield: Shield,
  smile: Smile,
  sprout: Sprout,
  star: Star,
  target: Target,
  'trending-up': TrendingUp,
  users: Users,
};

export const themeIconName = banner => {
  if (!banner) return null;
  const path = String(banner).split('?')[0];
  const file = path.substring(path.lastIndexOf('/') + 1);
  return file.replace(/\.svg$/i, '').toLowerCase() || null;
};

const ThemeIcon = ({banner, size = 20, strokeWidth = 2}) => {
  const Icon = ICONS[themeIconName(banner)] || Check;

  return <Icon size={size} strokeWidth={strokeWidth}/>;
};

export default ThemeIcon;
